import axios from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

export type RoleSection = "Pending" | "Completed" | "Deleted" | "Batches";
export type RolePermissionType = "Branch" | "Warehouse" | "VendorId" | "FreightVendorId";

export interface RolePermissionDto {
  section: RoleSection;
  permissionType: RolePermissionType;
  permissionValue: string;
}

export interface RoleDto {
  id: number;
  name: string;
  permissions: RolePermissionDto[];
}

export interface UpsertRoleRequest {
  name: string;
  permissions: RolePermissionDto[];
}

const auth = async (instance: IPublicClientApplication, account: any) => {
  const response = await instance.acquireTokenSilent({ ...apiRequest, account });
  return { headers: { Authorization: `Bearer ${response.accessToken}` } };
};

export const getRoles = async (instance: IPublicClientApplication, account: any): Promise<RoleDto[]> => {
  const config = await auth(instance, account);
  const res = await axios.get<RoleDto[]>(`${API_URL}/role`, config);
  return res.data;
};

export const getRole = async (instance: IPublicClientApplication, account: any, id: number): Promise<RoleDto> => {
  const config = await auth(instance, account);
  const res = await axios.get<RoleDto>(`${API_URL}/role/${id}`, config);
  return res.data;
};

export const createRole = async (instance: IPublicClientApplication, account: any, body: UpsertRoleRequest) => {
  const config = await auth(instance, account);
  const res = await axios.post<RoleDto>(`${API_URL}/role`, body, config);
  return res.data;
};

export const updateRole = async (instance: IPublicClientApplication, account: any, id: number, body: UpsertRoleRequest) => {
  const config = await auth(instance, account);
  const res = await axios.put<RoleDto>(`${API_URL}/role/${id}`, body, config);
  return res.data;
};

export const deleteRole = async (instance: IPublicClientApplication, account: any, id: number) => {
  const config = await auth(instance, account);
  await axios.delete(`${API_URL}/role/${id}`, config);
};

export const setUserRoles = async (instance: IPublicClientApplication, account: any, userId: number, roleIds: number[]) => {
  const config = await auth(instance, account);
  await axios.put(`${API_URL}/users/${userId}/roles`, { roleIds }, config);
};

export const setUserEntity = async (instance: IPublicClientApplication, account: any, userId: number, entityId: number | null) => {
  const config = await auth(instance, account);
  await axios.put(`${API_URL}/users/${userId}/entity`, { entityId }, config);
};
